import { Component, Input } from '@angular/core';
import { ConfigInitial } from '../../models';

@Component({
  selector: 'app-faq',
  standalone: false,
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {
  @Input() public configInitial!: ConfigInitial;
  public isVisibleModalFaq: boolean = false;

  public showModalFaq() : void {
    this.isVisibleModalFaq = true;
  }

  public handleCancelModalFaq() : void {
    this.isVisibleModalFaq = false;
  }

  public goToMail(correo: string): void {
    window.location.href = `mailto:${correo}`;
  }

  public goToCall(telefono: string): void {
    window.open(`tel:+52${telefono}`, '_system');
  }

  public goToWAPP(wapp: string): void {
    window.open(`https://wa.me/52${wapp}?text=Hola%2C+me+interesa+m%C3%A1s+informaci%C3%B3n+de+sus+productos`, '_blank', 'noopener');
  }
}
